import { Modal } from "antd";
import HTTPStatus from "http-status";
import { esborrarValors } from "../actions/sessio";
import { ERROR_CONSULTA_SERVIDOR } from "../actions/actionTypes";
import { eliminarToken } from "../utils/gestioWebToken";
import { NotificacioError } from "../components/Notification";

let modalErrorActiu;

const obrirModal = onOk => {
  if (modalErrorActiu) {
    modalErrorActiu.destroy();
  }

  modalErrorActiu = Modal.error({
    title: "Sessió caducada",
    content: "Es necessari fer login per accedir a l'aplicació.",
    okText: "Tornar a l'inici",
    onOk
  });
};

const errorsConsultaServidor = () => next => action => {
  if (action.type === ERROR_CONSULTA_SERVIDOR) {
    const { error, missatgePerUsuari } = action;
    if (error && error.status && error.status === HTTPStatus.UNAUTHORIZED) {
      const onOkModal = () => {
        eliminarToken();
        next(esborrarValors());
      };
      obrirModal(onOkModal);
      return;
    } else {
      NotificacioError(
        missatgePerUsuari,
        error.message ? error.message : "Avís error"
      );
      return;
    }
  }
  return next(action);
};

export default errorsConsultaServidor;
